import HttpService, {NotificationPolicy} from "service/web/HttpService";

/**
 * Backend-driven feature flags (GET /features) — the single source of truth, so the UI mirrors backend
 * toggles like chat.enabled rather than keeping its own config copy. The request is memoised so multiple
 * consumers (ChatPanel, AdminMenu) share one fetch; failures resolve to {} (everything off) without an
 * error toast.
 */
export default class FeatureWebService {

    static _flagsPromise = null;

    static getFlags = () => {
        if (!this._flagsPromise) {
            this._flagsPromise = HttpService.getAsync('/features', {notificationPolicy: NotificationPolicy.HIDE})
                .then(r => (r && r.data) || {});
        }
        return this._flagsPromise;
    }

    static isChatEnabled = async () => {
        const flags = await this.getFlags();
        return flags?.chatEnabled === true;
    }

    static isPageEventsEnabled = async () => {
        const flags = await this.getFlags();
        return flags?.pageEventsEnabled === true;
    }

    // reCAPTCHA v3 public site key, or null when reCAPTCHA isn't configured (disabled).
    static getRecaptchaKey = async () => {
        const flags = await this.getFlags();
        return flags?.recaptchaKey || null;
    }

    /**
     * The admin-configured premium price (single source of truth, ADR 0005): monthly amount in minor
     * units, ISO currency, and whether the paid flow is currently live. Used by the public pricing
     * pages so the advertised price mirrors the backend rather than being hardcoded.
     */
    static getPricing = async () => {
        const flags = await this.getFlags();
        return {
            monthlyAmount: flags?.subscriptionMonthlyAmount ?? null,
            currency: flags?.subscriptionCurrency || 'gbp',
            subscriptionsEnabled: flags?.subscriptionsEnabled === true,
        };
    }
}
